import * as THREE from "three";
import * as PANOLENS from "panolens";
import Stats from "stats.js"
import {createRotatingCube} from "./RotatingCube";

export const createOuterSphere = function (skyboxConfig, panorama) {
    console.log('createOuterSphere', skyboxConfig)
    const   x = skyboxConfig.x === undefined ? 0 : skyboxConfig.x,
            y = skyboxConfig.y === undefined ? 0 : skyboxConfig.y,
            z = skyboxConfig.z === undefined ? 0 : skyboxConfig.z,
            w = skyboxConfig.w === undefined ? 30 : skyboxConfig.w,
            h = skyboxConfig.h === undefined ? 30 : skyboxConfig.h,
            r = skyboxConfig.r === undefined ? 10000 : skyboxConfig.r,
            rotateX = skyboxConfig.rotateX === undefined ? 0 : skyboxConfig.rotateX,
            rotateY = skyboxConfig.rotateY === undefined ? 0 : skyboxConfig.rotateY,
            rotateZ = skyboxConfig.rotateZ === undefined ? 0 : skyboxConfig.rotateZ;

    if(!panorama.outerSphere){
        panorama.outerSphere = new THREE.Mesh(
            // USING A SPHERE GEOMETRY WITH A RADIUS OF 0.5
            new THREE.SphereGeometry(r, w, h),
            // standard material
            new THREE.MeshStandardMaterial({
                // color: 0xff0000,
                // emissive: 0x404040,
                side: THREE.DoubleSide
            }));
    }

    // mesh
    panorama.outerSphere.position.set(x, y, z);

    panorama.outerSphere.material.map = new THREE.TextureLoader().load( skyboxConfig.image )
    panorama.outerSphere.rotation.set(0,0,0);
    panorama.outerSphere.rotateY( rotateY)
    panorama.outerSphere.rotateZ( rotateZ)
    panorama.outerSphere.rotateX( rotateX)

    return panorama.outerSphere;
};

export function scene(imageSrc, alphaMapSrc, skyboxConfig) {

    let panorama = new PANOLENS.ImagePanorama(imageSrc);
    const _oldOnload = panorama.onLoad.bind(panorama);

    panorama.onLoad = function(texture){

        /* add alphaMap for windshield transparency */
        if(alphaMapSrc){
            // console.log('Loading alphamap from ', alphaMapSrc)
            // panorama.material.alphaMap = new THREE.TextureLoader().load( alphaMapSrc )
            // panorama.material.transparent = true
        }

        let scene = panorama.parent;

        /* test cube showing intersection at transparent mesh */
        // const cube = createRotatingCube(-5500, -1000, -2000, undefined, 2000);
        // cube.renderOrder = -1
        // window.cube = cube;
        // panorama.add(cube)

        /* add outer sphere for skybox */
        if(skyboxConfig){
            console.log('Loading skybox with config ', skyboxConfig)
            const sphere = createOuterSphere(skyboxConfig, panorama);
            scene.add(sphere);
        }

        _oldOnload(texture);
    }

    panorama.animationDuration = 0;
    return panorama;
}

export const b64TransparentImage = 'data:image/png;base64,' + 'iVBORw0KGgoAAAANSUhEUgAAAAEAAAABCAQAAAC1HAwCAAAAC0lEQVR42mNkYAAAAAYAAjCB0C8AAAAASUVORK5CYII='

export function createMarker(scale, name, texture){
    //transparent base64 marker https://png-pixel.com/
    //'data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAGQAAABkCAQAAADa613fAAAAaElEQVR42u3PQREAAAwCoNm/9CL496ABuREREREREREREREREREREREREREREREREREREREREREREREREREREREREREREREREREREREREREREREREREREREREREREREREREREREREWkezG8AZQ6nfncAAAAASUVORK5CYII='


    const marker = new PANOLENS.Infospot( scale, texture?texture:b64TransparentImage );
    marker.name = name;
    return marker;
}

export function viewer(element, render, options) {
    let viewer = new PANOLENS.Viewer(Object.assign({
        output: "console",
        renderer: render,
        container: element,
        cameraFov: 60,
        autoHideInfospot: false
    }, options?options:{}));
    return viewer;
}
let stats = null;
export function createStats() {
    if(stats !== null) return stats;
    stats = new Stats();
    stats.setMode(0);

    stats.domElement.style.position = 'relative';
    // stats.domElement.style.left = '0';
    // stats.domElement.style.top = '0';

    return stats;
}
export function renderer() {
    let renderer = new THREE.WebGLRenderer({ alpha: true, antialias: true });
    renderer.setPixelRatio(window.devicePixelRatio);
    renderer.setSize(window.innerWidth, window.innerHeight);
    renderer.sortObjects = true; //avoiding holes when rendering transparency

    //stats
    const stats = createStats();

    const parentRender = renderer.render.bind(renderer);
    renderer.render = (scene, camera) => {
        stats.update();
        parentRender(scene, camera);
    }

    return renderer;
}